import { render, staticRenderFns } from "./ConfirmedStudentList.vue?vue&type=template&id=54a3bcdc"
import script from "./ConfirmedStudentList.vue?vue&type=script&lang=js"
export * from "./ConfirmedStudentList.vue?vue&type=script&lang=js"
import style0 from "./ConfirmedStudentList.vue?vue&type=style&index=0&id=54a3bcdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports